import Vue from 'vue';
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue';
import { Icon } from '@iconify/vue2';
import VueCompositionAPI from '@vue/composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import '@axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { mask } from 'vue-the-mask';
import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/pt-br';
import 'swiper/css/swiper.css';
import '@/libs/filter.global';

// Global Components
import ptBr from 'element-ui/lib/locale/lang/pt-br';
import './global-components';
// 3rd party plugins
import '@/libs/portal-vue';
import Notifier from '@/libs/Notifier';
import App from './App.vue';
import store from './store';
import '@/libs/toastification';
import './registerServiceWorker';
import 'dotenv/config';
import '@/libs/acl';
import '@casl/ability';
import '@/libs/sweet-alerts';

import router from './router';

Vue.prototype.$notifier = new Notifier();
Vue.directive('mask', mask);
// BSV Plugin Registration
Vue.use(ElementUI, {
  locale: ptBr,
});

Vue.prototype.moment = moment;
Vue.component('iconfy', Icon);
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

Vue.use(ToastificationContent);
// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
